import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ChevronLeftIcon = createIcon({
  displayName: 'ChevronLeftIcon',
  path: (
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M13.25 8.75L9.75 12L13.25 15.25'
    />
  ),
  defaultProps: defaultProps
})
